'use client';

import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { dateDiff, getCurrentTime } from '../../../../common/utils';
import { salesRankingFactory } from '../../../../query-factory/salesRanking.factory';
import { toRelativeTimeString } from './utils';

export const LastUpdatedTime: FC = () => {
  const { data } = useQuery({
    ...salesRankingFactory.lastUpdatedAt,
  });

  const now = getCurrentTime();
  const lastUpdatedTime = data?.lastUpdatedAt;

  if (!lastUpdatedTime) {
    return <span />;
  }

  const diff = dateDiff(dayjs(lastUpdatedTime).toDate(), new Date(now), [
    'year',
    'month',
    'day',
    'hour',
    'minute',
  ]);

  return <span>{toRelativeTimeString(diff) ? `${toRelativeTimeString(diff)}전 갱신` : ''}</span>;
};
